<template>
  <v-layout>
    <v-chip
      text-color="white"
      label
      small
      :color="color"
    >
      {{ item.Title }}
    </v-chip>
  </v-layout>
</template>
<script>
export default {
  props: ["item"],
  computed: {
    color() {
      switch (this.item.Id) {
        case 0:
          return "red";
        case 1:
          return "green";
        case 2:
          return "orange";
        default:
          return "";
      }
    },
  },
};
</script>
